import React from 'react';
import { Typography } from 'antd';

const { Link } = Typography;

interface NameLinkProps {
  name: string;
  onClick: () => void;
}

/**
 * リストページで使用する名前リンクコンポーネント
 *
 * 標準デザイン:
 * - 太字
 * - 青文字 (#1890ff)
 * - クリック可能
 * - ホバー時に下線表示
 */
export const NameLink: React.FC<NameLinkProps> = ({ name, onClick }) => {
  return (
    <Link
      onClick={onClick}
      style={{
        fontWeight: 'bold',
        //color: '#1890ff',
      }}
    >
      {name}
    </Link>
  );
};

export default NameLink;
